<template>
  <div class="rate" :class="modifiers">
    <header v-if="title" class="rate__header">
      <BaseTitle
        v-bind="title"
        class="rate__title"
      />
    </header>
    <div class="rate__content">
      <button
        v-for="(item, i) in scores"
        :key="`rate_item_${i}`"
        class="rate__item"
        :class="{ rate__item_active: item.score === score }"
        type="button"
        @click="$emit('rate', item.score)"
      >
        <span>
          <BaseIcon
            v-if="item.icon"
            v-bind="item.icon"
            class="rate__icon"
          />
          <BaseTitle
            v-if="item.name"
            v-bind="item.name"
            class="rate__name"
            tag="b"
          />
        </span>
      </button>
    </div>
    <div v-if="$slots.actions" class="rate__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseTitle from '@/components/BaseTitle.vue';

export default {
  name: 'Rate',
  components: {
    BaseIcon,
    BaseTitle,
  },
  props: {
    title: {
      type: Object,
      default: null,
    },
    scores: {
      type: Array,
      default: () => [],
    },
    score: {
      type: Number,
    },
  },
  computed: {
    modifiers() {
      return {
        rate_selected: Boolean(this.score),
      };
    },
  },
};
</script>

<style lang="stylus">
.rate
  display flex
  flex-direction column
  width 100%
  height 100%
  text-align center

  &__content
    flex 1
    min-height 0
    display flex
    justify-content space-between
    padding-top 0.8em

  &__item
    display flex
    align-items center
    justify-content center
    flex 0 0 33.333333333333%
    max-width calc(33.333333333333% - (2em / 3))
    padding 0
    background none
    border 0
    height 100%
</style>
